exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-service-general-quotation-answer-forms[data-v-e657678c]{margin-top:2rem}.quotation-answer-card[data-v-e657678c]{border:1px solid #dee2e6;border-radius:.375rem}.card-header[data-v-e657678c]{background-color:#f8f9fa;border-bottom:1px solid #dee2e6}.alert-info[data-v-e657678c]{background-color:#d1ecf1;border-color:#bee5eb;color:#0c5460}", ""]);

// exports
